import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatAnchor, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { AdminComponentBase } from 'app/layout/content/admin-component-base';
import { PageSimpleContentComponent } from 'app/layout/content/page-simple-content.component';
import { AuthorizationContext, AuthorizationService } from 'app/shared/authentication';
import { ErrorComponent } from 'app/shared/components/error.component';
import { ConfirmDialogService } from 'app/shared/dialog/confirm-dialog-service';
import { GeneratedImageStoreAssociation, Store } from 'app/shared/graph';
import { CopyToClipboardComponent } from 'app/shared/utilities/copy-to-clipboard.component';
import { TruncatePipe } from 'app/shared/utilities/truncate.pipe';

import { GeneratedImagesService } from './generated-images.service';

@Component({
    templateUrl: './generated-image-store-associations-page.component.html',
    styleUrls: ['./generated-image-store-associations-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageSimpleContentComponent, RouterLink, MatAnchor, MatIcon, ErrorComponent, CopyToClipboardComponent, MatIconButton, MatMenuTrigger, MatMenu, MatMenuItem, MatDivider, TruncatePipe],
})
export class GeneratedImageStoreAssociationsPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly generatedImagesService = inject(GeneratedImagesService);
    private readonly authorizationService = inject(AuthorizationService);
    private readonly confirmDialogService = inject(ConfirmDialogService);
    private readonly route = inject(ActivatedRoute);

    storeId: string;
    authContext: AuthorizationContext;
    storeWithGeneratedImages?: Store;

    ngOnInit() {
        this.authorizationService.authorizationContext().subscribe((authContext) => {
            this.authContext = authContext;
        });
        this.registerSubscription(
            this.route.params.subscribe(params => {
                this.storeId = params.storeId;

                this.subscribeWithGenericLoadingErrorHandling(this.generatedImagesService.listStoreAssociations(this.storeId), (storeWithGeneratedImages) => {
                    this.storeWithGeneratedImages = storeWithGeneratedImages;
                });

            }));
    }

    ngOnDestroy() {
        this.unsubscribeSubscriptions();
    }

    delete(association: GeneratedImageStoreAssociation) {
        this.confirmDialogService.confirm(
            'Delete Generated Image'
            , `<p><strong>Deleting this may break existing projects.</strong></p>
<p>Be sure to provide an alternative version with the same alias to keep them working.</p>
 <p>Are you sure you want to delete the generated image association with the alias: <code>${association.alias}</code> ?</p>`,
            undefined,
            {
                yes: {
                    label: 'Delete',
                    warn: true,
                },
            })
            .subscribe(() => {
                this.subscribeWithGenericSavingErrorHandling(this.generatedImagesService.deleteGeneratedImageAssociation(association.id));
                let indexToRemove = this.storeWithGeneratedImages?.generatedImageAssociations.findIndex(x => x.id === association.id);
                this.storeWithGeneratedImages?.generatedImageAssociations.splice(indexToRemove!, 1);
            });
    }
}
